import React from "react";

import Table from 'react-bootstrap/Table';





import "./other.css";


const other = () => {
  return (
    <>
   





<span className="heading">Other Facilities</span>
<div className="fac-list">
    <Table striped bordered id="facilities-table">
      <thead>
        <tr>
          <th>Sr. No.</th>
          <th > Equipment Name</th>
         
        
        </tr>
      </thead>
      <tbody >
        
        <tr>
          <td>1</td>
          <td>X-ray diffraction system</td>
         
        
        </tr>
        <tr>
          <td>2</td>
          <td>Electrospinning</td>
        
        
        </tr>
        <tr>
          <td>3</td>
          <td>Electrochemical workstation</td>
         
        
        </tr>
        <tr>
          <td>4</td>
          <td>Potentiostat/Galvanostat</td>
         
        </tr>
        <tr>
          <td>5</td>
          <td>High Vacuum Thermal Evaporator</td>
        
        
        </tr>
        <tr>
          <td>6</td>
          <td>UV-VIS photometer</td>
        
        
        </tr>
        <tr>
          <td>7</td>
          <td>Contact Angle Meter</td>
      
        
        </tr>
        <tr>
          <td>8</td>
          <td>Photo-reactor</td>
       
        
        </tr>
        <tr>
          <td>9</td>
          <td>Hot-filament metal vapor deposition</td>
       
        
        </tr>
        <tr>
          <td>10</td>
          <td>Rotary Evaporator</td>
         
        
        </tr>
        <tr>
          <td>11</td>
          <td>Hot Air Oven</td>
        
        
        </tr>
        <tr>
          <td>12</td>
          <td>Ultrasonicator</td>
         
        
        </tr>
        <tr>
          <td>13</td>
          <td>Muffle Furnace</td>
       
        
        </tr>
        <tr>
          <td>14</td>
          <td>Spin Coater</td>
         
        </tr>
        <tr>
          <td>15</td>
          <td>Doctor Blade coater with heating arrangement</td>
        
        
        </tr>
        <tr>
          <td>16</td>
          <td>Hot press for electrode</td>
        
        
        </tr>
        <tr>
          <td>17</td>
          <td>Centrifuge machine</td>
      
        
        </tr>
        <tr>
          <td>18</td>
          <td>Hot and Cold mounting setup</td>
       
        
        </tr>
        <tr>
          <td>19</td>
          <td>Inverted microscope</td>
       
        
        </tr>
        <tr>
          <td>20</td>
          <td>FESEM</td>
       
        
        </tr>
        
        <tr>
          <td>21</td>
          <td>Jominy Hardenability Setup</td>
        
        
        </tr>
        <tr>
          <td>22</td>
          <td>Thermo-Gravimetric Analyzer (TGA)</td>
         
        
        </tr>
        <tr>
          <td>23</td>
          <td>Heat treatment vacuum tube furnace</td>
       
        
        </tr>
        <tr>
          <td>24</td>
          <td>Ultrasonic Flaw Detector</td>
         
        </tr>
        <tr>
          <td>25</td>
          <td>Universal Sheet Metal Testing Machine</td>
        
        
        </tr>
        <tr>
          <td>26</td>
          <td>CNC-Wire Cut-Electric Discharge Machine</td>
        
        
        </tr>
        <tr>
          <td>27</td>
          <td>100 Ton Capacity Hydraulic Press</td>
      
        
        </tr>
        <tr>
          <td>28</td>
          <td>Optical Microscope</td>
       
        
        </tr>
        <tr>
          <td>29</td>
          <td>Tubular Furnace</td>
       
        
        </tr>
        <tr>
          <td>30</td>
          <td>Polishing Machine</td>
       
        
        </tr>

        <tr>
          <td>31</td>
          <td>Yugma Chemical Etching Machine</td>
        
        
        </tr>
        <tr>
          <td>32</td>
          <td>2D Contact Type Surface Profilometer</td>
         
        
        </tr>
        <tr>
          <td>33</td>
          <td>Ducom High Temperature Wear Testing Machine</td>
       
        
        </tr>
        <tr>
          <td>
            34</td>
          <td>Magnum Pin/Ball On-Disk Wear Testing Machine</td>
         
        </tr>
        <tr>
          <td>35</td>
          <td>Impact forging machine</td>
        
        
        </tr>
        <tr>
          <td>36</td>
          <td>Salt Spray Test Chamber</td>
        
        
        </tr>
        <tr>
          <td>37</td>
          <td>Humidity Test Chamber</td>
      
        
        </tr>
        <tr>
          <td>38</td>
          <td>Horizontal Ball Milling Machine</td>
       
        
        </tr>
        <tr>
          <td>39</td>
          <td>Brinell Hardness Tester</td>
       
        
        </tr>
        <tr>
          <td>40</td>
          <td>Rockwell Hardness Tester</td>
       
        
        </tr>



        <tr>
          <td>41</td>
          <td>Universal Testing Machine</td>
        
        
        </tr>
        <tr>
          <td>42</td>
          <td>Impact Testing Machine</td>
         
        
        </tr>
        <tr>
          <td>43</td>
          <td>Vickers/Knoop Hardness Tester</td>
       
        
        </tr>
        <tr>
          <td>
            44</td>
          <td>Creep Testing Machine</td>
         
        </tr>
        <tr>
          <td>45</td>
          <td>Kolsky bar</td>
        
        
        </tr>
        <tr>
          <td>46</td>
          <td>TIG Welding machine</td>
        
        
        </tr>
        <tr>
          <td>47</td>
          <td>MIG Welding machine</td>
      
        
        </tr>
        <tr>
          <td>48</td>
          <td>Friction-stir Welding machine</td>
       
        
        </tr>
        <tr>
          <td>49</td>
          <td>CMT Welding machine</td>
       
        
        </tr>
        <tr>
          <td>50</td>
          <td>Resistance Spot Welding machine</td>
       
        
        </tr>




        <tr>
          <td>51</td>
          <td>Vacuum Arc Melting cum Suction Casting Unit with Turbomolecular Pump</td>
        
        
        </tr>
        <tr>
          <td>52</td>
          <td>Bottom Pouring Type Stir Casting Machine (BSCM)</td>
         
        
        </tr>
        <tr>
          <td>53</td>
          <td>Squeeze Casting Machine-for MMC in Aluminium and Magnesium</td>
       
        
        </tr>
        <tr>
          <td>
            54</td>
          <td>Salt spray chamber, FT-IR spectrometer (Spectrum two)</td>
         
        </tr>
        <tr>
          <td>55</td>
          <td>Conductivity meter</td>
        
        
        </tr>
        <tr>
          <td>56</td>
          <td>Fluorescence spectrometer (FL 8500)</td>
        
        
        </tr>
        <tr>
          <td>57</td>
          <td>pH meter</td>
      
        
        </tr>
        <tr>
          <td>58</td>
          <td>Corrosion analyzer (CHI 608E)</td>
       
        
        </tr>
        <tr>
          <td>59</td>
          <td>Digital multimeter, regulated power supply</td>
       
        
        </tr>
        <tr>
          <td>60</td>
          <td>Computer Cluster</td>
       
        
        </tr>





        <tr>
          <td>61</td>
          <td>VASP, LAMMPS, Octave, MATLAB, ThermoCalc, COMSOL, Abaqus
software</td>
        
        
        </tr>
        <tr>
          <td>62</td>
          <td>Fluorescence spectroscopy</td>
         
        
        </tr>
        <tr>
          <td>63</td>
          <td>IR spectroscopy</td>
       
        
        </tr>
        <tr>
          <td>
            64</td>
          <td>Scanning Electron Microscopy</td>
         
        </tr>
        <tr>
          <td>65</td>
          <td>Diffusion bonding machine</td>
        
        
        </tr>
        <tr>
          <td>66</td>
          <td>Mechanical testing facility (fatigue machine)</td>
        
        
        </tr>
        <tr>
          <td>67</td>
          <td>Hot extrusion machine</td>
      
        
        </tr>
        <tr>
          <td>68</td>
          <td>Electropolishing machine</td>
       
        
        </tr>
        <tr>
          <td>69</td>
          <td>Vibratory polishing machine</td>
       
        
        </tr>
        <tr>
          <td>70</td>
          <td>Wire arc additive manufacturing setup</td>
       
        
        </tr>





        <tr>
          <td>71</td>
          <td>MDDP Software </td>
        
        
        </tr>
        <tr>
          <td>72</td>
          <td>GNU Octave</td>
         
        
        </tr>
        <tr>
          <td>73</td>
          <td>Visco plastic self-consistent </td>
       
        
        </tr>
        <tr>
          <td>
            74</td>
          <td>ABAQUS-CAE FEM Software </td>
         
        </tr>
        <tr>
          <td>75</td>
          <td>Atomistic Simulation software LAMMPS </td>
        
        
        </tr>
        <tr>
          <td>76</td>
          <td>Density Functional Theory software</td>
        
        
        </tr>
        <tr>
          <td>77</td>
          <td>Hydrothermal Thin Film Synthesis set-up</td>
      
        
        </tr>
        <tr>
          <td>78</td>
          <td>RF/DC sputtering</td>
       
        
        </tr>
        <tr>
          <td>79</td>
          <td>Box type Furnaces</td>
       
        
        </tr>
        <tr>
          <td>80</td>
          <td>FTIR Spectroscope</td>
       
        
        </tr>





        <tr>
          <td>81</td>
          <td>Hall Coefficient measurement set-up</td>
        
        
        </tr>
        <tr>
          <td>82</td>
          <td>Solar cell simulator</td>
         
        
        </tr>
        <tr>
          <td>83</td>
          <td>MetrohmAutolab 302N Galvonostat /potentiostat</td>
       
        
        </tr>
        <tr>
          <td>
            84</td>
          <td>Vacuum Arc Melting cum Suction Casting Unit with Turbomolecular Pump</td>
         
        </tr>
        <tr>
          <td>85</td>
          <td>Bottom Pouring Type Stir Casting Machine (BSCM) </td>
        
        
        </tr>
        <tr>
          <td>86</td>
          <td>Squeeze Casting Machine-for MMC in Aluminium and Magnesium</td>
        
        
        </tr>
        <tr>
          <td>87</td>
          <td>Tube Sealing Unit</td>
      
        
        </tr>
        <tr>
          <td>88</td>
          <td>CNC- Wire cut Machine</td>
       
        
        </tr>
        <tr>
          <td>89</td>
          <td>Rolling machine</td>
       
        
        </tr>
        <tr>
          <td>90</td>
          <td>Ultrasonicator with Heater</td>
       
        
        </tr>
        
        
      </tbody>
    </Table>
</div>








    






    </>
  );
};

export default other;
